module.exports = __webpack_public_path__ + "img/iphone.1e449b3a.png";